
export default {        
    apiUrl: 'https://opsmonservicer.azurewebsites.net/api',
    apiKey: '05ubTHUp6vaMntCGjKX45cckJHYKkPcp'
};